import * as api from "../framework/api.js";

async function loadPage(path, page) {
  let url = new URL(path, window.location.origin);
  url.searchParams.append("page", page);
  return await api.fetchJSON(url);
}

async function loadAllPages(path, page, acc, transformPage) {
  let { data, is_last_page } = await loadPage(path, page);

  if (typeof transformPage === "function") {
    data = transformPage(data);
  }

  if (typeof is_last_page === "boolean") {
    return is_last_page ? [...acc, ...data] : loadAllPages(path, page + 1, [...acc, ...data], transformPage);
  }

  // Safety net for endpoints that don't return `is_last_page`: an empty page ends the loop.
  // This is a fallback only — always return `is_last_page` from the endpoint instead. Relying
  // on the empty-page heuristic silently truncates the result whenever a page can be empty
  // while later pages still hold data (e.g. paginating by training session but emitting one
  // row per customer: a page of sessions without customers stops the loop too early).
  if (data?.length == 0) {
    return acc;
  }

  return loadAllPages(path, page + 1, [...acc, ...data], transformPage);
}

export async function loadData(path, transformPage) {
  return await loadAllPages(path, 1, [], transformPage);
}
